export { default } from "./dayjsConfig";